export default {
    analytics(analytics) {
        const formattedDevices = analytics.deviceType && analytics.deviceType.join();
        return Object.assign(Object.assign({}, analytics), { deviceType: formattedDevices || analytics.deviceType });
    },
};
